import React, { memo } from "react";
import { FC } from "react";

type Props = {
  currency: string;
  name: string;
  isActive?: boolean;
  onClick: () => void;
};

const FiatItemComponent: FC<Props> = ({ currency, name, onClick, isActive }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        overflow: "hidden",
        height: "54px",
        padding: "14px",
        borderBottom: "1px solid #D7D7D7",
        backgroundColor: isActive ? "#EDEDED" : undefined,
      }}
      onClick={onClick}
    >
      <span
        style={{
          fontSize: "18px",
          lineHeight: "145%",
          fontWeight: 800,
          letterSpacing: "-0.36px",
          flex: 1,
        }}
      >
        {currency}
      </span>
      <span
        style={{
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          overflow: "hidden",
          fontSize: "18px",
          lineHeight: "145%",
          fontWeight: 800,
          letterSpacing: "-0.36px",
          color: "#8F8F8F",
        }}
      >
        {name}
      </span>
    </div>
  );
};

export const FiatItem = memo(FiatItemComponent);
